import { render, staticRenderFns } from "./NoContentReservas.vue?vue&type=template&id=687fc7ae&"
import script from "./NoContentReservas.vue?vue&type=script&lang=js&"
export * from "./NoContentReservas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports